import { useMenuChucNang } from "../hooks/useMenuChucNang";
import { CHUC_NANG_PERMISSION_CODES } from "./permissionConstants";
import routerConstants from "./routerConstants";
import {
    DatabaseOutlined,
    ShopOutlined,
    TagsOutlined,
    CarOutlined,
    DollarOutlined,
    GlobalOutlined,
    CalculatorOutlined,
    AppstoreOutlined,
    ShoppingOutlined,
    ShoppingCartOutlined,
    OrderedListOutlined,
    PayCircleOutlined,
    HistoryOutlined,
    ContainerOutlined,
    SearchOutlined,
    FileTextOutlined,
    BarcodeOutlined,
} from '@ant-design/icons';

interface IMenu {
    key: string;
    startPoint: string;
    path: string;
    label: string;
    icon: any;
    children: IMenu[];
}

export const useUserMenu = () => {
    const { hasMenu, hasChucNangByCode } = useMenuChucNang();

    const getMenu1 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.warehouse.list)) {
            availableMenus.push({ key: 'warehouse', startPoint: routerConstants.warehouse.name, path: routerConstants.warehouse.list, label: 'Kho', icon: DatabaseOutlined, children: [] });
        }
        if (hasMenu(routerConstants.supplier.list)) {
            availableMenus.push({ key: 'supplier', startPoint: routerConstants.supplier.name, path: routerConstants.supplier.list, label: 'Nhà cung cấp', icon: ShopOutlined, children: [] });
        }
        if (hasMenu(routerConstants.transportation.list)) {
            availableMenus.push({ key: 'transportation', startPoint: routerConstants.transportation.name, path: routerConstants.transportation.list, label: 'Hình thức vận chuyển', icon: CarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.rate.list)) {
            availableMenus.push({ key: 'rate', startPoint: routerConstants.rate.name, path: routerConstants.rate.list, label: 'Tỷ giá', icon: DollarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.transProvider.list)) {
            availableMenus.push({ key: 'transProvider', startPoint: routerConstants.transProvider.name, path: routerConstants.transProvider.list, label: 'NCC vận chuyển', icon: CarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.currencyProvider.list)) {
            availableMenus.push({ key: 'currencyProvider', startPoint: routerConstants.currencyProvider.name, path: routerConstants.currencyProvider.list, label: 'NCC tiền tệ', icon: GlobalOutlined, children: [] });
        }
        if (hasMenu(routerConstants.taxProvider.list)) {
            availableMenus.push({ key: 'taxProvider', startPoint: routerConstants.taxProvider.name, path: routerConstants.taxProvider.list, label: 'NCC thuế', icon: CalculatorOutlined, children: [] });
        }
        return availableMenus;
    };

    const getMenu2 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.categorie.list)) {
            availableMenus.push({ key: 'categorie', startPoint: routerConstants.categorie.name, path: routerConstants.categorie.list, label: 'Nhóm hàng hóa', icon: AppstoreOutlined, children: [] });
        }
        if (hasMenu(routerConstants.productGroup.list)) {
            availableMenus.push({ key: 'productGroup', startPoint: routerConstants.productGroup.name, path: routerConstants.productGroup.list, label: 'Nhóm công bố sản phẩm', icon: TagsOutlined, children: [] });
        }
        if (hasMenu(routerConstants.priceCategorie.list)) {
            availableMenus.push({ key: 'priceCategorie', startPoint: routerConstants.priceCategorie.name, path: routerConstants.priceCategorie.list, label: 'Nhóm giá', icon: DollarOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_LIST)) {
            availableMenus.push({ key: 'product', startPoint: routerConstants.product.name + "/", path: routerConstants.product.list, label: 'Sản phẩm', icon: ShoppingOutlined, children: [] });
        }

        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_NCC_LIST)) {
            availableMenus.push({ key: 'productSupplier', startPoint: routerConstants.product.listProductSupplier, path: routerConstants.product.listProductSupplier, label: 'Sản phẩm - NCC', icon: ShoppingOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_KHO_LIST)) {
            availableMenus.push({ key: 'producttWarehouse', startPoint: routerConstants.product.listProductWarehouse, path: routerConstants.product.listProductWarehouse, label: 'Sản phẩm - Kho', icon: ShoppingOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_NCC_KHO_LIST)) {
            availableMenus.push({ key: 'productAll', startPoint: routerConstants.product.listAll, path: routerConstants.product.listAll, label: 'Sản phẩm - NCC - Kho', icon: ShoppingOutlined, children: [] });
        }

        return availableMenus;
    };

    const getMenu3 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.purchasesRequest.list)) {
            availableMenus.push({ key: 'purchasesRequest', startPoint: routerConstants.purchasesRequest.name, path: routerConstants.purchasesRequest.list, label: 'Yêu cầu mua hàng', icon: ShoppingCartOutlined, children: [] });
        }
        if (hasMenu(routerConstants.requestShare.list)) {
            availableMenus.push({ key: 'requestShare', startPoint: routerConstants.requestShare.name, path: routerConstants.requestShare.list, label: 'Yêu cầu tách', icon: OrderedListOutlined, children: [] });
        }
        if (hasMenu(routerConstants.pricing.list)) {
            availableMenus.push({ key: 'pricing', startPoint: routerConstants.pricing.name, path: routerConstants.pricing.list, label: 'Báo giá', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.pricing.list)) {
            availableMenus.push({ key: 'pricingV2', startPoint: routerConstants.pricingV2.name, path: routerConstants.pricingV2.list, label: 'Báo giá V2', icon: FileTextOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PURCHASES_REQUEST_CONFIRM)) {
            availableMenus.push({ key: 'pricingConfirm', startPoint: routerConstants.pricingConfirm.name, path: routerConstants.pricingConfirm.list, label: 'Xác nhận báo giá', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.requestPayment.list)) {
            availableMenus.push({ key: 'requestPayment', startPoint: routerConstants.requestPayment.name, path: routerConstants.requestPayment.list, label: 'Yêu cầu thanh toán', icon: PayCircleOutlined, children: [] });
        }
        if (hasMenu(routerConstants.paymentOrder.list)) {
            availableMenus.push({ key: 'paymentOrder', startPoint: routerConstants.paymentOrder.name, path: routerConstants.paymentOrder.list, label: 'Thanh toán', icon: PayCircleOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.list)) {
            availableMenus.push({ key: 'order', startPoint: routerConstants.order.name, path: routerConstants.order.list, label: 'Đơn hàng', icon: OrderedListOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_ORDER_UPDATE_INFOR)) {
            availableMenus.push({ key: 'orderPurchasesUpdate', startPoint: routerConstants.orderPurchasesUpdate.name, path: routerConstants.orderPurchasesUpdate.list, label: 'Cập nhật đơn hàng', icon: OrderedListOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_ORDER_UPDATE_REALITY)) {
            availableMenus.push({ key: 'orderPurchasesReality', startPoint: routerConstants.orderPurchasesReality.name, path: routerConstants.orderPurchasesReality.list, label: 'Tính giá vốn', icon: CalculatorOutlined, children: [] });
        }
        return availableMenus;
    };

    const getMenu4 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_HISTORY_ORDER_LIST)) {
            availableMenus.push({ key: 'historyOrder', startPoint: routerConstants.historyOrder.name, path: routerConstants.historyOrder.list, label: 'Lịch sử đặt hàng', icon: HistoryOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_HISTORY_REALITY_LIST)) {
            availableMenus.push({ key: 'historyReality', startPoint: routerConstants.historyReality.name, path: routerConstants.historyReality.list, label: 'Lịch sử tính giá vốn', icon: HistoryOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_HISTORY_ORDER_DELETED_LIST)) {
            availableMenus.push({ key: 'historyOrderDeleted', startPoint: routerConstants.historyOrderDeleted.name, path: routerConstants.historyOrderDeleted.list, label: 'Lịch sử xóa đơn hàng', icon: HistoryOutlined, children: [] });
        }
        return availableMenus;
    };

    const getMenu5 = (): IMenu[] => {
        const containerChildren: IMenu[] = [];
        if (hasMenu(routerConstants.container.list)) {
            containerChildren.push({ key: 'container', startPoint: routerConstants.container.name, path: routerConstants.container.list, label: 'Gom cont', icon: ContainerOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CONTAINER_LIST)) {
            containerChildren.push({ key: 'containerV2', startPoint: routerConstants.containerV2.name, path: routerConstants.containerV2.list, label: 'Gom cont V2', icon: ContainerOutlined, children: [] });
        }
        const availableMenus: IMenu[] = [];
        if (containerChildren.length > 0) {
            availableMenus.push({
                key: 'container-group',
                startPoint: '/order-container/',
                path: '',
                label: 'Gom cont',
                icon: ContainerOutlined,
                children: containerChildren,
            });
        }
        return availableMenus;
    };

    const getMenu6 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.searchRequest.list)) {
            availableMenus.push({ key: 'searchRequest', startPoint: routerConstants.searchRequest.name, path: routerConstants.searchRequest.list, label: 'Yêu cầu tìm hàng', icon: SearchOutlined, children: [] });
        }
        if (hasMenu(routerConstants.productPricing.list)) {
            availableMenus.push({ key: 'productPricing', startPoint: routerConstants.productPricing.name, path: routerConstants.productPricing.list, label: 'Báo giá', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.productPricing.list)) {
            availableMenus.push({ key: 'productPricingDraft', startPoint: routerConstants.productPricingDraft.name, path: routerConstants.productPricingDraft.list, label: 'Báo giá nháp', icon: FileTextOutlined, children: [] });
        }
        if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_SEARCH_REQUEST_CONFIRM)) {
            availableMenus.push({ key: 'productPricingConfirm', startPoint: routerConstants.productPricingConfirm.name, path: routerConstants.productPricingConfirm.list, label: 'Xác nhận báo giá', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.productPricingHistory.list)) {
            availableMenus.push({ key: 'productPricingHistory', startPoint: routerConstants.productPricingHistory.name, path: routerConstants.productPricingHistory.list, label: 'Lịch sử', icon: HistoryOutlined, children: [] });
        }
        return availableMenus;
    };

    const getMenu7 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.report.reportDeptList_NCC_NGAYDATHANGTHUCTE)) {
            availableMenus.push({ key: 'reportNCC_NGAYDATHANGTHUCTE', startPoint: routerConstants.report.reportDeptList_NCC_NGAYDATHANGTHUCTE, path: routerConstants.report.reportDeptList_NCC_NGAYDATHANGTHUCTE, label: 'Công nợ đặt hàng', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.report.reportDeptList_NCC_NGAYPHATHANGTHUCTE)) {
            availableMenus.push({ key: 'reportNCC_NGAYPHATHANGTHUCTE', startPoint: routerConstants.report.reportDeptList_NCC_NGAYPHATHANGTHUCTE, path: routerConstants.report.reportDeptList_NCC_NGAYPHATHANGTHUCTE, label: 'Công nợ phát hàng', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.report.reportDeptList_NCC_THUCTE)) {
            availableMenus.push({ key: 'reportNCC_THUCTE', startPoint: routerConstants.report.reportDeptList_NCC_THUCTE, path: routerConstants.report.reportDeptList_NCC_THUCTE, label: 'Công nợ NCC - Kế toán', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.report.reportDeptList_NCCTHUE)) {
            availableMenus.push({ key: 'reportNCCTHUE', startPoint: routerConstants.report.reportDeptList_NCCTHUE, path: routerConstants.report.reportDeptList_NCCTHUE, label: 'Công nợ hoàn thuế', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.report.reportDeptList_NCCVC)) {
            availableMenus.push({ key: 'reportNCCVC', startPoint: routerConstants.report.reportDeptList_NCCVC, path: routerConstants.report.reportDeptList_NCCVC, label: 'Công nợ vận chuyển', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.report.reportDeptList_NCCTIENTE)) {
            availableMenus.push({ key: 'reportNCCTIENTE', startPoint: routerConstants.report.reportDeptList_NCCTIENTE, path: routerConstants.report.reportDeptList_NCCTIENTE, label: 'Công nợ tiền tệ', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.balanceOfdebt.list)) {
            availableMenus.push({ key: 'balanceOfdebt', startPoint: routerConstants.balanceOfdebt.list, path: routerConstants.balanceOfdebt.list, label: 'Cân bằng công nợ', icon: FileTextOutlined, children: [] });
        }
        // if (hasMenu(routerConstants.balanceOfdebt.list)) {
        //     availableMenus.push({ key: 'balanceOfdebtOrderAdd', startPoint: routerConstants.balanceOfdebt.orderAdd, path: routerConstants.balanceOfdebt.orderAdd, label: 'Cân bằng đơn hàng', icon: FileTextOutlined, children: [] });
        // }
        return availableMenus;
    };

    const getMenu8 = (): IMenu[] => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.billOfLadingCode.list)) {
            availableMenus.push({ key: 'billOfLadingCode', startPoint: routerConstants.billOfLadingCode.name, path: routerConstants.billOfLadingCode.list, label: 'Mã vận đơn', icon: BarcodeOutlined, children: [] });
        }
        return availableMenus;
    };

    // get menu 
    const menu1 = getMenu1();
    const menu2 = getMenu2();
    const menu3 = getMenu3();
    const menu4 = getMenu4();
    const menu5 = getMenu5();
    const menu6 = getMenu6()
    const menu7 = getMenu7();
    const menu8 = getMenu8();


    let menuApps: IMenu[] = [];

    if (menu1.length > 0) {
        menuApps.push({
            key: 'admin',
            startPoint: "/admin/",
            path: '',
            label: 'Dữ liệu nguồn',
            icon: DatabaseOutlined,
            children: menu1
        });
    }

    if (menu2.length > 0) {
        menuApps.push({
            key: 'admin-product',
            startPoint: "/admin-product/",
            path: '',
            label: 'Sản phẩm',
            icon: AppstoreOutlined,
            children: menu2
        });
    }

    if (menu3.length > 0) {
        menuApps.push({
            key: 'order',
            startPoint: "/order/",
            path: '',
            label: 'Mua hàng',
            icon: ShoppingCartOutlined,
            children: menu3
        });
    }

    if (menu4.length > 0) {
        menuApps.push({
            key: 'history',
            startPoint: "/history/",
            path: '',
            label: 'Lịch sử',
            icon: HistoryOutlined,
            children: menu4
        });
    }

    if (menu5.length > 0) {
        menuApps = [...menuApps, ...menu5];
    }

    if (menu6.length > 0) {
        menuApps.push({
            key: 'find-product',
            startPoint: "/find-product/",
            path: '',
            label: 'Tìm hàng',
            icon: SearchOutlined,
            children: menu6
        });
    }

    if (menu7.length > 0) {
        menuApps.push({
            key: 'report',
            startPoint: "/report/",
            path: '',
            label: 'Báo cáo',
            icon: FileTextOutlined,
            children: menu7
        });
    }

    if (menu8.length > 0) {
        menuApps = [...menuApps, ...menu8];
    }

    return menuApps;
};